/* eslint-disable operator-linebreak */
import { createAction } from "@reduxjs/toolkit";
import { ILoanType } from "app/interfaces/loan-type/loan-type.interface";

export const GET_LOAN_TYPE = 'GET_LOAN_TYPE';
export const SET_LOAN_TYPE = 'SET_LOAN_TYPE';

export interface ILoanTypeResponse {
    code: string;
    data: ILoanType[];
    message: string;
}

export const getLoanTypeAction =
    createAction(
		GET_LOAN_TYPE
	);

export const setLoanTypeAction =
    createAction<ILoanTypeResponse>(
		SET_LOAN_TYPE
	);
